export enum WeightUnits {
  KG = '0',
  LB = '1'
}
